import { render, staticRenderFns } from "./caidan.vue?vue&type=template&id=943d5f0c&scoped=true"
import script from "./caidan.vue?vue&type=script&lang=js"
export * from "./caidan.vue?vue&type=script&lang=js"
import style0 from "./caidan.vue?vue&type=style&index=0&id=943d5f0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "943d5f0c",
  null
  
)

export default component.exports